export default () => {
  return {
    bottonProgress: {
      pointerEvents: 'none',
    },
  }
}
